<template>
  <base-page
    shoutType="catering"
    class="PlanNowPage">
    <template slot="header">
      <page-header :showNavigationBar="true"/>
    </template>

    <div class="BodyContent Container">
      <div
        id="contact"
        class="Section EnquirySection">
        <base-header :title="$t('catering.enquirySectionTitle')">
          <span
            slot="byline"
            v-html="$t('catering.enquirySectionByline')"/>
        </base-header>
        <enquiry-form/>
        <base-header>
          <div
            slot="byline"
            class="AfterEnquiryForm"
            v-html="
              $t('catering.afterEnquiryForm', {
                phoneLink: `<a class='Button--text' href='tel:+6531635335'>+65 3163 5335</a>`,
                emailLink: `<a class='Button--text' href='mailto:experience@grain.com.sg'>experience@grain.com.sg</a>`
              })
            "/>
        </base-header>
      </div>
    </div>

    <template slot="footer">
      <page-footer/>
    </template>
  </base-page>
</template>

<script>
import BaseHeader from '@/components/common/BaseHeader'
import BasePage from '@/components/common/BasePage'
import EnquiryForm from '@/components/EnquiryForm'
import PageFooter from '@/components/PageFooter'
import PageHeader from '@/components/PageHeader'

export default {
  name: 'plan-now-page',
  metaInfo() {
    const title = 'Plan Your Event | Grain Catering Singapore'
    const description = 'Start planning your perfect catering experience with Grain. Contact us for personalized menu recommendations and event planning.'
    return {
      title,
      meta: [
        { name: 'robots', content: process.env.VUE_APP_ENVIRONMENT === 'production' ? 'all' : 'none' },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: title
        },
        {
          vmid: 'description',
          name: 'description',
          content: description
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content: description
        }
      ]
    }
  },
  components: {
    BasePage,
    PageFooter,
    PageHeader,
    BaseHeader,
    EnquiryForm
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/base';
@import '~@/assets/css/_shared_variables.sass';

.PlanNowPage {
  .BodyContent {
    position: relative;
    margin-top: $space-m;

    .Section {
      margin-bottom: $space-l;

      &:last-child {
        margin-bottom: 0;
      }

      &.EnquirySection {
        .BaseHeader {
          text-align: center;

          /deep/ .Button--text {
            white-space: nowrap;
          }
        }

        .AfterEnquiryForm {
          max-width: 500px;
          margin: 0 auto;
        }
      }
    }
  }
}
</style>
